import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import { MenuItem, Typography } from '@material-ui/core'

import { usePlace } from 'commons/usePlace'
import { SECONDARY } from 'app/constants/button'
import { SubscriberMenuAction } from 'app/constants/subscriberCRM'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const ReInvited = (props) => {
  const {
    closeMenu = () => {},
    onAction,
    rootAdmin = {},
    selected = [],
    selectedCount = null,
  } = props

  const place = usePlace()
  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)
  const [isDisable, setIsDisable] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  useEffect(() => {
    const checkDisable =
      selected.length === 1 && selected.includes(place.creatorId)
    setIsDisable(checkDisable)
  }, [place.creatorId, selected])

  return (
    <div>
      {
        <MenuItem onClick={() => handleOpen()} className="space-x-5">
          <ExitToAppIcon fontSize="small" className="text-blue-500" />
          <Typography className="text-14 font-400 text-blue-500">
            {formatMessage({
              id: 'teamMembers.lable.reInvite',
            })}
          </Typography>
        </MenuItem>
      }

      <SubmitDialog
        id="dialog-reinvite-subscriber"
        open={isOpen}
        type={SECONDARY}
        title={formatMessage({
          id: 'subscriber.reinvite.title',
        })}
        description={formatMessage({
          id: 'subscriber.reinvite.description',
        })}
        submitText={formatMessage({
          id: 'teamMembers.lable.reInvite',
        })}
        onSubmit={() => {
          onAction(SubscriberMenuAction.REINVITE, selected)
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </div>
  )
}

ReInvited.propTypes = {
  onAction: PropTypes.func,
  selected: PropTypes.array,
  closeMenu: PropTypes.func,
  className: PropTypes.string,
  rootAdmin: PropTypes.object,
  selectedCount: PropTypes.number,
}

export default ReInvited
